import eventsData from './apiServices/eventsData.json';
import formulasData from './apiServices/formulasData.json';
import featuresTooltips from './apiServices/featuresTooltips.json';
import defaultFeatures from './apiServices/defaultFeatures.json';
import integrationCardsWithoutStatuses from './apiServices/integrationCards.json';
import apiBoards from '@/api/apiBoards';
import {getUrlParam} from '@/helpers/urlHelper';
import {eventBus} from '../main';
import {getBoardId, getTestMetaData} from '../helpers/testData';
import {setRevenueNames} from "../pages/Dashboard/mapping";
import defaultTemplates from "../pages/Dashboard/FormulasBlock/FormulasTemplates.json";


const isTestMode = false;
let metaData = {};
let additionalMetaData = {};
let events = [];
let eventsWithData = [];
let formulas = [];
let formulasWithData = [];
let features = [];
let featuresWithData = [];
let precisions = [];
let boards = [];
let boardset = [];
let boardsetFromRequest = [];
const defaultFeaturesWithData = defaultFeatures;
let projects = [];
let projectsWithData = [];
let integrationCards = [];
let currentAdIntegrations = [];
let user = {};
let emitUpdateMeta = null;
let sourceGroups = [];

const defaultBoardProperties = {
    groupByCohort: true,
};
const adminPages = ['/users', '/applications', '/postback', '/setup', '/urls', '/offerings'];
const featuresWithRevenueEvents = ['summary','bundle_id', 'product_id', 'geo', 'test', 'test_name', 'source'];
let summaryEvents = [];
const revenueEvents = [];

window.savedRequests = {
    dashboard: {},
    users: {},
    apps: {},
    integrations: {},
};

export const setMetaData = function (data) {
    metaData = _.cloneDeep(data);
};
export const setAdditionaMetaData = function (propertyName, data) {
    additionalMetaData[propertyName] = _.cloneDeep(data);
};
export const setEmitUpdateMeta = function (callback) {
    emitUpdateMeta = callback;
};

export const getBugRequestData = function () {
    return {
        metaData,
        allData: getAllData(),
        additionalMetaData: additionalMetaData,
        savedRequests: window.savedRequests,
    };
};

export const getAllData = function () {
    return {
        events,
        eventsWithData,
        formulas,
        formulasWithData,
        features,
        featuresWithData,
        precisions,
        boards,
        boardset,
        boardsetFromRequest,
        defaultFeaturesWithData,
        projects,
        projectsWithData,
        integrationCards,
        user,
    };
};

export const setEvents = function (data) {
    events = data;
};

export const setUser = function (data) {
    user = data;
};

export function setEventsWithData() {
    eventsWithData = events.map((event) => {
        const currentEvent = eventsData.find((ed) => ed.name === event);
        if (currentEvent) {
            return {
                name: event,
                color: currentEvent ? currentEvent.color : '#000000',
                fontWeight: currentEvent.fontWeight,
            };
        }
        return {
            name: event,
            color: '#000000',
            fontWeight: 400,
        };
    });
    setRevenueNames(eventsWithData);
    _.cloneDeep(eventsWithData).map(event => {
        if (event.name.startsWith("revenue") && event.name.length > 7) {
            revenueEvents.push(event.name);
        }
    });
    summaryEvents = _.cloneDeep(revenueEvents);
    ['active_trials', 'paying_users'].forEach((eventName) => {
        if (eventsWithData.find((event) => event.name === eventName) && !summaryEvents.includes(eventName)) {
            summaryEvents.push(eventName);
        }
    });
}


export const setFormulas = function (data) {
    formulas = data;
};

export function setFormulasWithData() {
    formulasWithData = formulas;
}

export const setFeatures = function (data) {
    features = data;
};

export const setSourceGroups = function (groupsFromResponse) {
    const groups = groupsFromResponse.map((groupFromResponse) => {
        const group = groupFromResponse;
        group.events = groupFromResponse.events.map((event) => {
            return eventsWithData.find((eventsWithData) => eventsWithData.name === event);
        });
        return group;
    });
    sourceGroups = groups;
};

export const setPrecisions = function (data) {
    precisions = data;
};

export const assignIfNotExist = function (object, properyName, data) {
    if (!object[properyName]) {
        object[properyName] = data;
    }
};

export const setBoards = function (data) {
    const allFeaturesNames = featuresWithData.map((f) => f.name);
    const allEventsNames = eventsWithData.map((f) => f.name);
    const allProjectsBundlesIds = projectsWithData.map((f) => f.bundle_id);

    function updateBoardsProperties(oldBoards) {
        const newBoards = _.cloneDeep(oldBoards).map((board) => {
            board.features = board.features.filter((feature) => allFeaturesNames.includes(feature.name));
            board.events = Object.freeze(board.events.filter((event) => allEventsNames.includes(event.name)));
            assignIfNotExist(board, 'eventsOrder', Object.freeze(board.events.map((event) => event.name)));
            assignIfNotExist(board, 'additionalColumnsByFeatureName', {});
            assignIfNotExist(board, 'historyActivations', []);
            assignIfNotExist(board.additionalColumnsByFeatureName, 'product_id', [{
                name: 'ARPPU',
                type: 'input',
                width: 40,
                data: {},
                updateFeaturesNames: [],
            }]);

            board.additionalColumnsByFeatureName.summary = [];
            // assignIfNotExist(board.additionalColumnsByFeatureName, 'summary', [{
            //     name: 'pROMI',
            //     type: 'text',
            //     width: 40,
            //     data: {},
            //     updateFeaturesNames: [],
            // }]);
            // board.additionalColumnsByFeatureName.summary[0].title = 'pROMI';
            // board.additionalColumnsByFeatureName.summary[0].name = 'pROMI';
            // board.additionalColumnsByFeatureName.summary[0].tooltip = '';
            board.additionalColumnsByFeatureName.product_id[0].title = 'ARPPU';

            board.projects = board.projects.filter((project) => allProjectsBundlesIds.includes(project.bundle_id));

            board.tempData = {
                areSubscriptionsUpdating: false,
                arePredictionsUpdating: false,
                isFeaturesUpdating: false,
                isSummaryTableUpdating: false,
                isEditingSettingsDisabled: false,
                isDashboardLoaded: false,
                areAdditionalSubscriptionsLoading: false,
                areHistoryActivationsUpdating: false,
                isHistoryUpdating: false,
                costsSubscription: null,
                arrpusDefault: {},
                cancelTokenSources: {
                    slice: null,
                    history: null,
                    subscriptions: null,
                    predictions: null,
                    historyActivations: null,
                    arrpus: null,
                },

            };
            //delete old properties
            delete board.isNeedLoad;
            delete board.allFeatures;
            return board;
        });
        return newBoards;
    }

    boards = Object.freeze(updateBoardsProperties(data));
};
export const setBoardset = function (data) {
    boardset = (data || []).filter(id => id != null && id !== '');
    boardsetFromRequest = data;
};

export const getIsEditMode = function () {
    return !(!boardsetFromRequest && getBoards().length);
};

export function setFeaturesWithData() {
    featuresWithData = features.map((feature) => ({
        name: feature,
        tooltip: featuresTooltips[feature],
        filters: [],
    }));
}

export const setProjects = function (data) {
    projects = data;
};

export const setProjectsWithData = function () {
    projectsWithData = projects.map((project) => ({
        ...project,
    }));
};
export const setIntegrationCards = function (integrationStatuses) {
    const cards = integrationCardsWithoutStatuses;
    Object.keys(integrationStatuses).forEach((status) => {
        const card = cards.find((card) => card.type === status);
        if (card) {
            Object.assign(card, integrationStatuses[status]);
        }
    });
    integrationCards = cards;
};

export const setCurrentAdIntegrations = function (newCurrentAdIntegrations) {
    currentAdIntegrations = newCurrentAdIntegrations;
};

export const getCurrentAdIntegrations = function () {
    return currentAdIntegrations;
};

export function getUser() {
    return _.cloneDeep(user);
}

export function getAdminPages() {
    return _.cloneDeep(adminPages);
}

export function getFeaturesWithRevenueEvents() {
    return _.cloneDeep(featuresWithRevenueEvents);
}

export function getSummaryEvents() {
    return _.cloneDeep(summaryEvents);
}

export function getEvents() {
    return events;
}

export function getEventsWithData() {
    return _.cloneDeep(eventsWithData);
}

export function getFormulas() {
    return formulas;
}

export function getFormulasWithData() {
    return formulasWithData;
}

export function getFeatures() {
    return _.cloneDeep(features);
}

export function getSourceGroups() {
    return sourceGroups;
}

export function getFeaturesWithData() {
    return featuresWithData;
}

export function getFeatureWithDataByName(name) {
    return featuresWithData.find((feature) => feature.name === name);
}

export function getDefaultFeatureWithDataByName(name) {
    return defaultFeaturesWithData.find((feature) => feature.name === name);
}

export function getProjects() {
    return projects;
}

export function getProjectsWithData() {
    return _.cloneDeep(projectsWithData);
}

export function deleteProjectByBundleId(bundleId) {
    projectsWithData = projectsWithData.filter((project) => project.bundle_id !== bundleId);
    boards.forEach((board) => {
        const normalizedProjects = [];
        board.projects.forEach((project) => {
            const normalizedProject = projectsWithData.find((projectWithData) => projectWithData.bundle_id === project.bundle_id);
            if (normalizedProject) {
                normalizedProjects.push(normalizedProject);
            }
        });
        board.isFirstTimeLoaded = false;
        board.projects = normalizedProjects;
    });
}

export function addProject(project) {
    projectsWithData.push(project);
    boards.forEach((board) => {
        board.isFirstTimeLoaded = false;
    });
}

export function updateProjectByBundleId(newProject) {
    const project = projectsWithData.find((project) => project.bundle_id === newProject.bundle_id);
    Object.assign(project, newProject);
    boards.forEach((board) => {
        const normalizedProjects = [];
        board.projects.forEach((project) => {
            const normalizedProject = projectsWithData.find((projectWithData) => projectWithData.bundle_id === project.bundle_id);
            if (normalizedProject) {
                normalizedProjects.push(normalizedProject);
            }
        });
        board.isFirstTimeLoaded = false;
        board.projects = normalizedProjects;
    });
}

export const getPrecisions = function () {
    return precisions;
};
export const getBoards = function () {
    return boards;
};
export const getBoardset = function () {
    return boardset;
};
export const getBoardsetIndexById = function (id) {
    return boardset.findIndex((board) => board === id);
};
export const getProjectById = function (id) {
    return projectsWithData.find((project) => project.bundle_id === id);
};
export const getProjectByName = function (name) {
    return projectsWithData.find((project) => project.name === name);
};
export const getIntegrationCards = function () {
    return integrationCards;
};

export const isTestBoardsMode = function () {
    return isTestMode;
};

export const initPreload = function () {
    if (isTestMode) {
        const boardId = getBoardId();
        return apiBoards.getBoardById(boardId).then(() => {
            initData(getTestMetaData());
        });
    } else {
        let boardId;
        if (getUrlParam('board_id')) {
            boardId = getUrlParam('board_id');
        }
        if (boardId) {
            return apiBoards.getBoardById(boardId).then((response) => {
                initData(response);
            });
        } else {
            return apiBoards.getBoards().then((response) => {
                initData(response);
            });
        }
    }

    function initData(response) {
        setEvents(response.data.events);
        setFormulas(formulasData);
        setFeatures(response.data.features);

        setProjects(response.data.projects);
        setPrecisions(response.data.precisions);
        setUser(response.data.user);
        setBoardset(response.data.boardset);
        setEventsWithData();
        setSourceGroups(response.data.source_groups);
        setFeaturesWithData();
        setFormulasWithData();
        setProjectsWithData();
        setMetaData(response.data);
        setAdditionaMetaData('meta', response.data);

        const boards = [];

        const revenueTemplates = [];
        _.cloneDeep(eventsWithData.map((f) => f.name)).map(eventName => {
            if (eventName.startsWith("revenue") && eventName.length > 7) {
                const number = eventName.match(/\d+/)[0];
                revenueTemplates.push({
                    equation: `100*(${eventName}*coef-expense)/expense`,
                    isActive: true,
                    isTemplate: true,
                    name: `romi${number}`,
                });
            }
        });
        revenueTemplates.sort((a, b) => {
            const numberA = parseInt(a.name.match(/\d+/)[0], 10);
            const numberB = parseInt(b.name.match(/\d+/)[0], 10);
            return numberA - numberB;
        });
        const formulasTemplates = revenueTemplates.concat(_.cloneDeep(defaultTemplates));
        const formulasTemplateNames = formulasTemplates.map(({name}) => name)

        const normalizeBoard = (boardFromApi, boardId) => {
            const board = Object.assign(_.cloneDeep(defaultBoardProperties), boardFromApi);
            board.id = boardId;
            board.loadedId = board.id;
            board.uniqueId = boardId;
            board.styles = {
                hiddenColumnsStyles: '',
                columnsColorStyles: '',
                selectedRowsStyles: '',
            };
            board.savedData = {
                events: [],
                features: [],
                period: '',
                sessionFeaturesSettings: {},
            };
            board.componentsSettings = normalizeComponentsSettings(board.componentsSettings);
            if (board.arppuCoef == null) {
                board.arppuCoef = true;
            }

            if (!board.currentSource) {
                board.currentSource = getSourceGroups()[0];
            } else {
                const displayedActiveFeaturesNames = board.currentSource.displayedActiveFeaturesNames;
                const currentSource = getSourceGroups().find((group) => group.name === board.currentSource.name);
                if (currentSource) {
                    board.currentSource = currentSource;
                    if (displayedActiveFeaturesNames && displayedActiveFeaturesNames.length) {
                        board.currentSource.displayedActiveFeaturesNames = displayedActiveFeaturesNames.filter((displayName) => currentSource.features.includes(displayName));
                    }
                } else {
                    board.currentSource = getSourceGroups()[0];
                }
            }
            board.events = normalizeEvents(board.events);
            board.formulas = normalizeFormulas(formulasTemplates, formulasTemplateNames, board.formulas);
            board.eventsOrder = normalizeEventsOrder(board.events);
            board.projects = normalizeProjects(board.projects);
            board.features = normalizeFeatures(board.features);
            board.datePeriod = normalizeDatePeriod(board.datePeriod);

            if (board.featuresSettings) {
                Object.values(board.featuresSettings).forEach((featureSetting) => {
                    if (featureSetting.width && typeof featureSetting.width !== 'number') {
                        delete featureSetting.width;
                    }
                    if (featureSetting.nameWidth && typeof featureSetting.nameWidth !== 'number') {
                        delete featureSetting.nameWidth;
                    }

                    if (!featureSetting.deletedEventsNames) {
                        featureSetting.deletedEventsNames = [];
                    }

                    if (!featureSetting.showRevenues) {
                        revenueEvents.forEach((revenueEvent) => {
                            if (!featureSetting.deletedEventsNames.includes(revenueEvent)) {
                                featureSetting.deletedEventsNames.push(revenueEvent);
                            }
                        });
                    }
                });
            }
            if (!board.currentSource.displayedActiveFeaturesNames) {
                board.currentSource.displayedActiveFeaturesNames = board.features.map((feature) => feature.name);
            }
            // eslint-disable-next-line
            if (!board.hasOwnProperty('refundPercent')) {
                board.refundPercent = null;
            }
            return board;
        };
        if (getBoardset().length) {
            response.data.boardset.forEach((id) => {
                if (!id || !response.data.boards[id]) return;
                const board = _.cloneDeep(response.data.boards[id]);
                boards.push(_.cloneDeep(normalizeBoard(board, id)));
            });
        } else {
            Object.entries(response.data.boards).forEach(([id, board]) => {
                if (!id || board == null) return;
                boards.push(normalizeBoard(board, id));
            });

        }
        setBoards(Object.freeze(boards));
        if (emitUpdateMeta) {
            emitUpdateMeta();
        }
        eventBus.$emit('DashboardInitBoards');
    }

    function normalizeComponentsSettings(componentsSettings) {
        const newComponentSettings = _.cloneDeep(componentsSettings) || {};
        newComponentSettings.dateTimeHistory = newComponentSettings.dateTimeHistory || [];
        return newComponentSettings;
    }

    function normalizeEvents(events) {
        const normalizedEvents = [];
        events.forEach((event) => {
            if (event) {
                const normalizedEvent = eventsWithData.find((eventWithData) => eventWithData.name === event.name);
                if (normalizedEvent) {
                    normalizedEvents.push(normalizedEvent);
                }
            }
        });
        return normalizedEvents;
    }

    function normalizeFormulas(templates, templateNames, formulas) {
       const templateFormulas = templateNames
            .map((templateName, index) => {

                const newFormula = formulas.find(formula => formula.name === templateName);
                if(newFormula){
                    newFormula.equation = templates[index].equation;
                }
                return newFormula
            })
            .filter(Boolean);


        const otherFormulas = formulas.filter(formula => !templateNames.includes(formula.name));


        return [...templateFormulas, ...otherFormulas];
    }


    function normalizeEventsOrder(events) {
        return events.map(({name}) => name);
    }

    function normalizeProjects(projects) {
        const normalizedProjects = [];
        const addedProjectsIds = {};
        projects.forEach((project) => {
            const normalizedProject = projectsWithData.find((projectWithData) => projectWithData.bundle_id === project.bundle_id);
            if (normalizedProject && !addedProjectsIds[normalizedProject.bundle_id]) {
                addedProjectsIds[normalizedProject.bundle_id] = true;
                normalizedProjects.push(normalizedProject);
            }
        });
        return normalizedProjects;
    }

    function normalizeFeatures(features) {
        const normalizedFeatures = [];
        features.forEach((feature) => {
            const normalizedFeature = featuresWithData.find((featureWithData) => featureWithData.name === feature.name);
            if (normalizedFeature) {
                normalizedFeatures.push(normalizedFeature);
            }
        });
        return normalizedFeatures;
    }

    function normalizeDatePeriod(datePeriod) {
        if (datePeriod.preset === '7 days') {
            datePeriod.preset = 'Last 7 days';
        }
        return datePeriod;
    }

};
